import React from 'react';

function CTA() {
  return (
    <section className="cta scroll-reveal">
      <h2>Comienza a trabajar con EduAgentic</h2>
      <a href="#" className="btn-secondary gradient-primary btn-animated">Regístrate y comienza ahora</a>

      <div className="footer-info">
        <span>🔒 100% Seguro</span>
        <span>🧰 Soporte técnico</span>
        <span>🎓 Garantía de uso académico</span>
      </div>
    </section>
  );
}

export default CTA;
